// IMPORTS
// =============================================================
import $ from "jquery";
import { init as initFlyout } from "./modules/flyout.module.js";
import { init as initFlyoutSearch } from "./modules/flyoutSearch.module.js";

if (document.querySelector(".swiper-container")) {
  import("./modules/swiper.module.js").then((module) => module.init());
}

if (document.querySelector(".swiper-container.chart-slider")) {
  import("./modules/swiperChart.module.js").then((module) => module.init());
}

if (document.querySelector(".circles-slider")) {
  import("./modules/swiperCircles.module.js").then((module) => module.init());
}

if (document.querySelector(".numbers-slider")) {
  import("./modules/swiperNumbers.module.js").then((module) => module.init());
}

if (document.querySelector(".flip-cards")) {
  import("./modules/flipcardModal.module.js").then((module) => module.init());
}

if (document.querySelector(".breadcrumb")) {
  import("./modules/breadcrumbs.module.js").then((module) => module.init());
}

if (document.querySelector(".sticky-sidebar")) {
  import("./modules/stickySidebar.module.js").then((module) => module.init());
}

if (document.querySelector(".ctype-asjobs_offers")) {
  import("./modules/asJobs.module.js").then((module) => module.init());
} else {
  sessionStorage.removeItem("asJobsForm");
}

if (document.querySelector("select[multiple]")) {
  import("./modules/multiselect.module.js").then((module) => module.init());
}

if (document.querySelector(".powermail_field")) {
  import("./modules/powermail.module.js").then((module) => module.init());
}

if (document.querySelector("#InputLexiconSearch")) {
  import("./modules/lexiconSearch.module.js").then((module) => module.init());
}

// =============================================================
// WHEN COMPLETE
// functions which are called when the page is fully loaded
// =============================================================
let attempts = 0;
const whenComplete = () => {
  if (++attempts > 30) return;
  if (document.readyState === "complete") {
    //Main menu
    initFlyout();

    //Site Search
    initFlyoutSearch();

    // -------------------------------------------------------------
    // MD modal
    // Import and init BS5 modal module when a modal is present
    // -------------------------------------------------------------

    if (document.querySelector(".modal")) {
      import("./modules/modal.module.js").then((module) => module.init());
    }

    // -------------------------------------------------------------
    // MD accordion
    // Import and init Accordion  module when a accordion is present
    // -------------------------------------------------------------
    if (document.querySelector(".acc")) {
      import("./modules/accordion.module.js").then((module) => module.init());
    }

    // -------------------------------------------------------------
    // MD Career tabs
    // Import and init Career tabs  module when a career-desk is present
    // -------------------------------------------------------------
    if (document.querySelector(".career-desk")) {
      import("./modules/careerTabs.module.js").then((module) => module.init());
    }

    // -------------------------------------------------------------
    // MD Counter
    // Import and init Counter  module when a counters is present
    // -------------------------------------------------------------
    if (document.querySelector(".counters")) {
      import("./modules/counter.module.js").then((module) => module.init());
    }

    // -------------------------------------------------------------
    // MD Animation on scroll
    // Import and init Animation on scroll module when a animate is present
    // -------------------------------------------------------------
    if (document.querySelector(".animate")) {
      import("./modules/animationOnScroll.module.js").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // MD Modal Navigation
    // Import and init Modal Navigation module when a modal-nav is present
    // -------------------------------------------------------------
    if (document.querySelector(".modal-nav")) {
      import("./modules/modalNav.module.js").then((module) => {
        module.init();
      });
    }

    /* ------- anchor menu -------- */
    if (document.querySelector(".anchor-menu")) {
      import("./modules/anchorMenu.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".lightbox")) {
      import("./modules/lightbox.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".panel")) {
      import("./modules/panel.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".training__filter")) {
      import("./modules/filterTabs.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".modal")) {
      import("./modules/standardModal.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".ctype-news_newssearchform #searchDemand")) {
      import("./modules/newsSearch.module.js").then((module) => {
        module.init();
      });
    }

    if (
      document.querySelector(".ctype-sfeventmgt_pieventsearch #searchDemand")
    ) {
      import("./modules/sfEventSearch.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelector(".ctype-ce_treatment_spectrum, .ctype-container_treatment_spectrum")) {
      import("./modules/ceTreatmentSpectrum.module.js").then((module) => {
        module.init();
      });
    }

    /*---------sticky header---------*/
    const updateStickyHeader = () => {
      if (window.scrollY >= 50) {
        document.body.classList.add("sticky-header");
      } else {
        document.body.classList.remove("sticky-header");
      }
      if (window.innerWidth < 1200) {
        document.body.classList.add("sticky-header");
      }
    };
    $(window).on("resize scroll", updateStickyHeader);
    updateStickyHeader();

    // anchor link fix
    let elHeader = document.querySelector('header.header')
    let elBreadcrumb = document.querySelector('.breadcrumb-bar')
    let totalHeight = 0
    if(elHeader)
        totalHeight += elHeader.offsetHeight
    if(elBreadcrumb)
        totalHeight += elBreadcrumb.offsetHeight
    if(!!window.location.hash){

        let targetElement = document.getElementById(window.location.hash.substring(1));
        let targetY = 0
        if(targetElement)
            targetY = targetElement.getBoundingClientRect().top

        setTimeout(() => window.scrollBy({top: targetY - totalHeight}), 10)

    }
    /*---------/sticky header ---------*/

    /*------- scroll to top ------------*/
    const updateScrollToTop = () => {
      if ($(window).scrollTop() > 50) {
        $("#scroll-to-top").addClass("active");
      } else {
        $("#scroll-to-top").removeClass("active");
      }
    };
    updateScrollToTop();
    $(window).on("load resize scroll", updateScrollToTop);
    /*------- /scroll to top ------------*/
  } else {
    setTimeout(() => whenComplete(), 400);
  }
};
whenComplete();

// =============================================================
// STYLES COMPLETE
// Removes styles_essential when general styles are loaded
// =============================================================
let styleAttempts = 0;
const stylesComplete = () => {
  if (++styleAttempts > 30) return;
  if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
    document.querySelector("#sess").remove();
  } else {
    setTimeout(() => stylesComplete(), 300);
  }
};
stylesComplete();
